import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/color-metal-nobackground.png'


const _withScopeId = n => (_pushScopeId("data-v-5f42d7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-center-content-horizontal" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-container",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "app-center-content-horizontal title_portal" }
const _hoisted_4 = {
  style: {"display":"flex","align-items":"center","max-height":"36px","min-height":"36px","width":"100%","justify-content":"center"},
  class: "q-px-sm"
}
const _hoisted_5 = {
  key: 0,
  style: {"padding":"2rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "input-container title_autentificare"
}
const _hoisted_8 = {
  key: 1,
  class: "input-container title_autentificare"
}
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { style: {"font-family":"'Roboto', sans-serif","font-size":"1.2rem"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "input-container" }
const _hoisted_14 = { style: {"font-family":"'Roboto', sans-serif","font-size":"1.2rem"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { style: {"font-family":"'Roboto', sans-serif","font-size":"1.2rem"} }
const _hoisted_17 = { class: "btn-container" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "app-center-content-horizontal"
}
const _hoisted_20 = {
  key: 1,
  class: "app-center-content-horizontal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('message.portal_partners')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_q_select, {
        outlined: "",
        modelValue: _ctx.selectedLang,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLang) = $event)),
          _cache[1] || (_cache[1] = val => _ctx.changeLanguage(val))
        ],
        options: _ctx.languages,
        "option-value": "id",
        "option-label": "name",
        class: "form__input",
        "emit-value": "",
        dense: "",
        "map-options": ""
      }, null, 8, ["modelValue", "options"])
    ]),
    (_ctx.isUserAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.type == '1')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('message.set_password')), 1))
            : _createCommentVNode("", true),
          (_ctx.type == '2')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('message.reset_password')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('message.user')), 1),
            _createVNode(_component_q_input, {
              placeholder: _ctx.$t('message.user'),
              outlined: "",
              style: {"max-height":"7vh","font-family":"'Roboto', sans-serif","font-size":"1.2rem"},
              modelValue: _ctx.user,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user) = $event)),
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnPassword, ["prevent"]), ["enter"]),
              "lazy-rules": "",
              dense: "",
              disable: ""
            }, null, 8, ["placeholder", "modelValue", "onKeydown"])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.password')), 1),
            _createVNode(_component_q_input, {
              placeholder: _ctx.$t('message.password'),
              outlined: "",
              style: {"max-height":"7vh","font-family":"'Roboto', sans-serif","font-size":"1.2rem"},
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
              type: _ctx.isPwd ? 'password' : 'text',
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnBtnLogin, ["prevent"]), ["enter"]),
              ref: "refPassword",
              "lazy-rules": "",
              dense: "",
              rules: [val => !!val || _ctx.$t('message.camp_obligatoriu')]
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                  class: "cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue", "type", "onKeydown", "rules"]),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.confirm_password')), 1),
            _createVNode(_component_q_input, {
              placeholder: _ctx.$t('message.confirm_password'),
              outlined: "",
              style: {"max-height":"7vh","font-family":"'Roboto', sans-serif","font-size":"1.2rem"},
              modelValue: _ctx.confirmPassword,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: _ctx.isPwd ? 'password' : 'text',
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnBtnLogin, ["prevent"]), ["enter"]),
              ref: "refPassword",
              "lazy-rules": "",
              dense: "",
              rules: [val => !!val || _ctx.$t('message.camp_obligatoriu')]
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                  class: "cursor-pointer",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue", "type", "onKeydown", "rules"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.type == '1')
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  "no-caps": "",
                  label: _ctx.$t('message.set_password'),
                  color: "primary",
                  loading: _ctx.ajaxIsLoading,
                  "text-color": "black",
                  ref: "refBtnLogin",
                  onClick: _ctx.onSubmitLoginData
                }, null, 8, ["label", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.type == '2')
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  "no-caps": "",
                  label: _ctx.$t('message.reset_password'),
                  color: "primary",
                  loading: _ctx.ajaxIsLoading,
                  "text-color": "black",
                  ref: "refBtnLogin",
                  onClick: _ctx.onSubmitLoginData
                }, null, 8, ["label", "loading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.type == '1')
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t('message.invalid_token_set_password')), 1))
            : _createCommentVNode("", true),
          (_ctx.type == '2')
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t('message.invalid_token_reset_password')), 1))
            : _createCommentVNode("", true)
        ]))
  ]))
}